/* Agreements + agreement-label resolvers (verbatim from mockup core.js). */
import {SUPPLY_DATA} from './_v6Data'

export const DUMMY_AGREEMENTS = SUPPLY_DATA.agreements

export const agreementsFor = (parentId) => DUMMY_AGREEMENTS.filter((a) => a.parentId === parentId)
export const agreementById = (id) => DUMMY_AGREEMENTS.find((a) => a.id === id)
export const agreementShort = (id) => {
  const a = agreementById(id)
  if (!a) return id
  return a.type === 'Commercial Addendum' ? 'Addendum #' + a.addendumNo : a.type
}
export const agreementLabel = (id) => {
  const a = agreementById(id)
  if (!a) return id
  return agreementShort(id) + ' — ' + a.title
}
